// 极简请求封装，替代 axios。
// 移除 axios 同时省下它约 50KB 的本体，以及它引用全局 Buffer 而连带打进来的
// buffer/base64-js/ieee754 polyfill（约 19KB）。
//
// 用 XMLHttpRequest 而不是 fetch：fetch 在 IE11 与部分老 Android WebView 上不存在，
// 而本站 browserslist 仍覆盖这些浏览器（.babelrc 也还在为它们注入 core-js polyfill），
// 换 fetch 会造成浏览器支持回退。XHR 则到处都有。
//
// 语义对齐 axios：2xx 才 resolve，其余 reject —— 与原实现完全一致，
// 所以调用方的 try/catch 行为不变。
export function request(url, options) {
  const opts = options || {}
  const method = opts.method || 'GET'

  let full = url
  if (opts.params) {
    const qs = Object.keys(opts.params)
      .filter(k => opts.params[k] != null)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(opts.params[k]))
      .join('&')
    if (qs) full += (full.indexOf('?') > -1 ? '&' : '?') + qs
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(method, full, true)

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) return

      // 对应 axios 的默认 validateStatus：仅 2xx 视为成功
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new Error('Request failed with status code ' + xhr.status))
        return
      }

      let data = xhr.responseText
      try {
        data = JSON.parse(data)
      } catch (e) {
        /* 非 JSON 响应保留原文，与 axios 行为一致 */
      }
      resolve({ status: xhr.status, data })
    }

    xhr.onerror = () => reject(new Error('Network Error'))
    xhr.ontimeout = () => reject(new Error('Timeout'))

    if (opts.data !== undefined) {
      xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8')
      xhr.send(JSON.stringify(opts.data))
    } else {
      xhr.send()
    }
  })
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js